import Box from '@material-ui/core/Box'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import ErrorIcon from '@material-ui/icons/Error'
import React from 'react'
import { ErrorListProps } from 'react-jsonschema-form'

import { H6 } from '../../utils/typography'

const ErrorList = ({ errors }: ErrorListProps) => (
  <Paper elevation={2}>
    <Box mb={2} p={2}>
      <H6>Errors</H6>

      <List dense>
        {errors.map(error => (
          <ListItem key={[error.property, error.message].join('/')}>
            <ListItemIcon>
              <ErrorIcon color="error" />
            </ListItemIcon>
            <ListItemText primary={error.stack} />
          </ListItem>
        ))}
      </List>
    </Box>
  </Paper>
)

export default ErrorList
